<!--婴幼儿管理-->
<template>
  <div class="app-container">
    <!--查询条件区域-->
    <div class="title-container" shadow="never">
      <div class="title-con">
        <i class="el-icon-search"></i>
        <span style="margin-left: 5px;">筛选搜索</span>
      </div>
    </div>
    <el-card class="operate-container" shadow="never" style="margin-top: 0px;">
      <div class="filter-container" style="margin-top: 10px">
        <el-form :inline="true" :model="queryParam" label-width="120px">
          <el-form-item label="家长手机号:">
            <el-input v-model="queryParam.userPhone" placeholder="输入手机号"></el-input>
          </el-form-item>
          <el-form-item label="会员姓名:">
            <el-input v-model="queryParam.name" placeholder="输入会员姓名"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="button-container" style="margin-top: 0px">
        <el-button type="warning" size="medium" class="operator-btn2" icon="el-icon-refresh" @click="handleResetSearch()">重 置</el-button>
        <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-search" @click="onBtnSearch()">查 询</el-button>
      </div>
    </el-card>

    <div class="title-container" shadow="never" style="margin-top: 10px;">
      <div class="title-con">
        <i class="el-icon-tickets"></i>
        <span style="margin-left: 5px;">数据列表</span>
      </div>
    </div>
    <div class="table-container" style="margin-top: 0px;">
      <el-table ref="tableData"
                style="width: 100%"
                :data="tableData"
                v-loading="tableloading" border
                highlight-current-row
                :header-cell-style="{'text-align':'center'}"
                :cell-style="{'text-align':'center'}"
                @row-click="rowClick"
                @selection-change="handleSelectionChange">
        <el-table-column label="手机号" prop="phoneNumber" width="180">
        </el-table-column>
        <el-table-column label="客户名称" prop="parentName">
        </el-table-column>
        <el-table-column label="孩子名称" prop="childName">
        </el-table-column>
        <el-table-column label="孩子月龄" prop="childMonth">
        </el-table-column>
        <el-table-column label="孩子生日" prop="childBirthday">
        </el-table-column>
        <el-table-column label="购买卡名称" prop="cardName">
        </el-table-column>
        <el-table-column label="最后消费时间" prop="lastUseCardTime">
        </el-table-column>
        <el-table-column label="来源" prop="vipDisplayValue">
        </el-table-column>
        <el-table-column label="过期原因" prop="typeDisplayValue">
        </el-table-column>
        
      </el-table>
    </div>
    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="queryParam.pageNum"
        :page-size="queryParam.pageSize"
        :page-sizes="queryParam.pageSizes"
        :total="queryParam.totalPage">
      </el-pagination>
    </div>
  </div>
</template>

<style scoped>
  /deep/ .el-table th.el-table__cell>.cell{
    width: 90%;
    height: auto;
    background: #ecf3fd;
    border-radius: 8px;
  }
  /deep/ .el-table__header-wrapper .cell{
    line-height: 45px;
    color: #0d6fb8;
  }
  /deep/ .el-dialog--center{
    border: 2px solid #d0d0d0;
    border-radius: 10px;
  }
  /deep/ .el-dialog__header{
    border-radius: 10px;
    background: #f0f7ff;
  }

</style>

<script>
  import UserChildDetail from './components/UserChildDetail'
  import BuyLessonCardDetail from '../user-by-lesson-card/components/BuyLessonCardDetail'
  import {publicPoolList} from "../../api/userChild";
  import commonUtils from "../../utils/commonUtils";
  import globaldata from "../../utils/globaldata";
  import WorkerWord from "../../components/WorkerWord/WorkerWord";
  import enumsUtil, {EChildGender} from "../../utils/enumsUtil";
  import messageUtils from "../../utils/messageUtils";
  import BookLessonForChild from "../components/BookLessonForChild";
  import {selectCards} from "../../api/storeFront";
  import UpdateChildInfo from "./components/UpdateChildInfo";
  import CreateCule from "../marketing-manager/components/CreateCule";
  import UserBuyExpCard from "./components/UserBuyExpCard";
  import UserChangeExpCard from "./components/UserChangeExpCard";
  import ChangeChildLevel from "../components/ChangeChildLevel";
  export default {
     components: {
       UserChangeExpCard,ChangeChildLevel,
       UserBuyExpCard,
       CreateCule, UpdateChildInfo, BookLessonForChild, WorkerWord,UserChildDetail,BuyLessonCardDetail },    data() {
      return {

        //弹窗
        visibleDlgAdd:false,
        visibleDlgBook:false,
        visibleDlgInfo:false,
        visibleDlgDelete:false,
        visibleDlgWord:false,
        visibleDlgUpdateChildInfo:false,
        visibleDlgAddClue:false,
        visibleDlgBuyExpCard:false,
        visibleDlgChangeExpCard:false,
        visibleDlgUpdateChildLevel:false,
        addRefresh:"",
        updateRefresh:"",
        refreshWord:"",
        queryParam:{
          userPhone: '',     //输入手机号
          name:'',  //输入会员孩子名
          sliderMonthValue : [0,100],
          sliderMonthMarks: {
            0: '0',
            50: '50',
            100: '100',

          },
          //分页查询
          pageNum :1 ,//当前第几页
          totalPage :1, //总共页数
          pageSize : 10,
          pageSizes:[10,20,30],
        },

        storeLessonVIPCards:[], //VIP卡
        storeLessonEXPCards:[], //体验卡
        showAddCardDlg:false,
        refreshCard:"",

        buyParam:{},

        createParam:{

        },

        //表单结果
        tableData: [],
        tableloading: true,
        selectRow:null,
        updateChildId:0,
        changeChildLevelId:0,
        refreshchangeChildLevel:"",
        clueInfo:"",
        allWorker:"",

        refreshBuyExpCard:"",
        buyExpCardChild:"",
        changeExpCardChild:"",
        refreshChangeExpCard:"",
      }
    },
    created(){
      globaldata.getStoreWorkersInfo(this.getStoreWorkersInfo);
      this.getStoreLessonCard()

    },
    activated(){
    },
    mounted() {
    },
    methods: {
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      handleCurrentChange(val) {
        this.queryParam.pageNum = val;
        this.flechList();
      },
      handleSizeChange(val) {
        this.queryParam.pageSize = val;
        this.fitchList();
      },
      handleResetSearch(){
        this.queryParam.userPhone = ''
        this.queryParam.name = ''
      },
      getStoreLessonCard(){
        let param = {
          storeFrontId: globaldata.getAdminStore().storeFrontId,
          statu:0,
          exp:null,
        }
        selectCards(param).then(response =>
        {
          let data = response.data;
          this.storeLessonVIPCards = [];
          this.storeLessonEXPCards = [];
          for (let i = 0;i< data.length;++i){
            if (data[i].experience ==1){
              this.storeLessonEXPCards.push(data[i]);
            } else {
              this.storeLessonVIPCards.push(data[i]);
            }
          }
          this.flechList();
        })

      },
      getStoreWorkersInfo(workers){
        this.allWorker = workers;
      },
      flechList(){
        this.tableloading = true;
        let param = {
          storeFrontId:globaldata.getAdminStore().storeFrontId,
          name: this.queryParam.name,
          userPhone : this.queryParam.userPhone,
          pageNum : this.queryParam.pageNum ,//当前第几页
          pageSize :  this.queryParam.pageSize,
        }
        publicPoolList(param).then(response =>
        {
          this.tableloading = false;
          let date = response.data;
          if (commonUtils.isObjectNull(date)){
            return;
          }
          this.queryParam.totalPage = date.total;
          this.refreshData(date.list);

        })
      },
      //刷新页面数据
      refreshData(list){
        if (commonUtils.isObjectNull(list)){
          return;
        }
        this.tableData = list;
      },

      rowClick(row, column, event){
        this.selectRow = row;
      },
      handleCheckSelect(){
        if (commonUtils.isObjectNull(this.selectRow)){
          messageUtils.errorMsg(this,"请先选择一条信息");
          return false;
        }
        return true;
      },
      onChangeSuccessShowDlg(){
        if (commonUtils.isObjectNull(this.selectRow)){
          messageUtils.errorMsg(this,"请先选择一条信息");
          return false;
        }
        this.changeChildLevelId = this.selectRow.id;
        this.refreshchangeChildLevel = new Date().getTime();
        this.visibleDlgUpdateChildLevel = true;
      },

      //点击查询按钮
      onBtnSearch(){
        this.flechList();
      },




    }
  }
</script>






// WEBPACK FOOTER //
// src/views/user_child/publicPoolList.vue